export default "__VITE_ASSET__8727aacc__"